/**
 * Validation
 */

import { validationRules } from './validation-rules';

const validation = (() => {
  let _o = {
    inputs: null,
    recaptcha: null,
    recaptchas: null,
    selectors: {
      rules: '[data-validation-rules]',
      form: '[data-validation-form]',
    },
  };

  let status = [];
  let errorFallbackCounter = 0;
  let errorFallbackValidCounter = 0;

  const init = () => {
    validationRules.init();
    initEvents();
  };

  const initEvents = () => {
    const forms = document.querySelectorAll(_o.selectors.form);
    const inputs = document.querySelectorAll(_o.selectors.form + ' ' + _o.selectors.rules);

    forms.forEach((form) => {
      form.addEventListener('submit', submitForm);
    });

    inputs.forEach((input) => {
      input.addEventListener('change', validateInput);
      input.addEventListener('focusout', validateInput);
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    status = [];
    errorFallbackCounter = 0;
    const form = e.target;
    const inputs = form.querySelectorAll(_o.selectors.rules);
    const action = form.querySelector('input[name=action]');

    const recaptcha = validateGrecaptcha(form);
    const errorContainer = form.querySelector('[data-form-error]');

    inputs.forEach((input) => validateInput(input));

    setTimeout(() => {
      if (errorFallbackCounter !== 0) {
        if (errorFallbackCounter === status.filter((v) => v === false).length) {
          errorFallbackValidCounter++;
        } else {
          errorFallbackValidCounter = 0;
        }
      }

      if (
        recaptcha &&
        (!status.includes(false) || (errorFallbackCounter > 0 && errorFallbackValidCounter > 1))
      ) {
        let request = new XMLHttpRequest();
        request.onreadystatechange = function () {
          if (request.status >= 200 && request.status < 300) {
            // Runs when the request is successful
            const jsonResponse = JSON.parse(request.responseText);
            const isResponseValid =
              jsonResponse.status !== undefined && jsonResponse.status !== 'ERROR';

            if (isResponseValid) {
              setFormError(errorContainer, '');
              formSubmitted(form);
            } else {
              let errorMessage = 'Nieznany błąd. Spróbuj ponownie za chwilę';

              if (jsonResponse.error) errorMessage = jsonResponse.error;

              if (jsonResponse.errors) {
                const errors = [];

                jsonResponse.errors.forEach((error) => {
                  errors.push(error.message);
                });

                errorMessage = errors.join(', ');
              }

              setFormError(errorContainer, errorMessage);
            }
          } else {
            if (!request.response) return;

            setFormError(errorContainer, 'Nieznany błąd. Spróbuj ponownie za chwilę.');
          }
        };
        request.open('POST', form.getAttribute('action'), true);

        // const fileInput = form.querySelector("[type=file]");

        const fd = new FormData(form);

        request.send(fd);
      }
    });
  };

  const formSubmitted = (form) => {
    form.reset();

    let formSubmitted = form.querySelector('[data-form-submitted]');

    if (formSubmitted) {
      formSubmitted.classList.add('submitted');
      formSubmitted.setAttribute('role', 'alert');
      const p = formSubmitted.querySelector('p');
      const actionElems = form.querySelectorAll('input, select, label, a, button');
      p.setAttribute('tabindex', '0');
      p.focus();

      actionElems.forEach((actionEl) => actionEl.setAttribute('tabindex', '-1'));

      setTimeout(function () {
        formSubmitted.classList.remove('submitted');
        actionElems.forEach((actionEl) => actionEl.removeAttribute('tabindex'));
      }, 10000);
    }
  };

  const serializeArray = (formData) => {
    let pairs = {};

    // Add each name/value pair to the array
    for (const [name, value] of formData) {
      pairs[name] = value;
    }

    console.log(pairs);
    return pairs;
  };

  const validateGrecaptcha = (form) => {
    _o.recaptcha = form.querySelector('.g-recaptcha');

    if (!_o.recaptcha || !grecaptcha || !allRecaptchas || allRecaptchas.length === 0) return true;

    // const id = _o.recaptcha.getAttribute('id');

    const widgetId = [...document.querySelectorAll('.g-recaptcha')].findIndex(
      (el) => el === _o.recaptcha,
    );

    const response = grecaptcha.getResponse(widgetId);

    if (!response) {
      setError(_o.recaptcha, 'Pole wymagane.');
    }

    return response;
  };

  const recaptchaCallback = (response) => {
    if (response) setSuccess(_o.recaptcha);
  };

  const recaptchaSuccess = () => {
    setSuccess(_o.recaptcha);
  };

  const validateInput = (input) => {
    if (input.target) input = input.target;

    let rules = getValidationRules(input);
    let type = input.getAttribute('type');
    let value,
      size = '';
    let isAnyError = false;
    let validateResponse;

    switch (type) {
      case 'checkbox':
        value = input.checked;
        break;
      case 'file':
        if (input.files[0]) {
          value = input.files[0].type;
          size = input.files[0].size;
        } else {
          value = '';
        }
        break;
      default:
        value = input.value;
    }

    for (let i = 0; i < rules.length; i++) {
      let currentRule = validationRules.returnValidationRule(rules[i]);
      validateResponse = currentRule(value, type, size, input);

      if (validateResponse.error) {
        if (validateResponse?.errorFallback === true) {
          errorFallbackCounter++;
        }

        isAnyError = true;

        break;
      } else {
        isAnyError = false;
      }
    }

    //skip errors if element is not visible
    if (input.offsetParent === null) isAnyError = false;

    status.push(!isAnyError);

    if (isAnyError) {
      setError(input, validateResponse.msg);
    } else {
      setSuccess(input);
    }
  };

  const getValidationRules = (element) => {
    let data = element.dataset.validationRules;
    return data.split(',');
  };

  const setError = (element, msg) => {
    const container = element.closest('.input-wrapper') || element.parentNode;

    if (container.classList.contains('error')) {
      const alert = container.querySelector('small');
      alert.innerHTML = msg;
    } else {
      container.classList.add('error');

      let alert = document.createElement('small');
      alert.setAttribute('role', 'alert');
      alert.innerHTML = msg;
      container.appendChild(alert);
    }
  };

  const setSuccess = (element) => {
    const container = element.closest('.input-wrapper') || element.parentNode;

    const alert = container.querySelector('small');
    if (alert) container.removeChild(alert);

    container.classList.remove('error');
  };

  const setFormError = (messageContainer, message) => {
    const isParagraph = messageContainer.querySelector('p');

    if (isParagraph) {
      isParagraph.innerText = message;
    } else {
      const paragraph = document.createElement('p');
      const text = document.createTextNode(message);
      paragraph.appendChild(text);
      messageContainer.appendChild(paragraph);
    }
  };

  return {
    init,
    recaptchaSuccess,
    recaptchaCallback,
  };
})();

window.recaptchaCallback = validation.recaptchaCallback;

export { validation };
